import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./Package.css";

function Package() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [package_, setPackage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  useEffect(() => {
    const fetchPackage = async () => {
      try {
        const res = await axios.get(`https://ttfadmin.onrender.com/api/itineraries/${id}`);
        setPackage(res.data);
      } catch (err) {
        console.error("Failed to load package:", err);
        navigate("/itineraries"); // Redirect to itineraries on error
      } finally {
        setLoading(false);
      }
    };

    fetchPackage();
  }, [id, navigate]);

  if (loading) {
    return (
      <div className="package-loading">
        <div className="spinner"></div>
        <p>Loading package details...</p>
      </div>
    );
  }

  if (!package_) return null;

  return (
    <div className="package-page">
      <div className="package-hero">
        <button className="back-button" onClick={() => navigate("/itineraries")}>
          ← Back to Itineraries
        </button>
        <h1>{package_.title}</h1>
        <div className="package-meta">
          <span className="duration">
            {package_.duration?.nights}N / {package_.duration?.days}D
          </span>
          <span className="locations">{package_.locations?.join(" → ")}</span>
        </div>
      </div>

      <div className="package-content">
        <div className="gallery-section">
          <div className="main-image-container">
            <img
              src={package_.images?.[activeImageIndex] || package_.coverImage}
              alt={package_.title}
              className="main-image"
            />
            <div className="gallery-nav">
              <button
                onClick={() => setActiveImageIndex((i) => (i - 1 + package_.images.length) % package_.images.length)}
                className="nav-button"
                disabled={!package_.images?.length}
              >
                ←
              </button>
              <button
                onClick={() => setActiveImageIndex((i) => (i + 1) % package_.images.length)}
                className="nav-button"
                disabled={!package_.images?.length}
              >
                →
              </button>
            </div>
          </div>
          <div className="thumbnail-strip">
            {package_.images?.map((img, i) => (
              <button
                key={i}
                className={`thumb-btn ${i === activeImageIndex ? "active" : ""}`}
                onClick={() => setActiveImageIndex(i)}
              >
                <img src={img} alt={`View ${i + 1}`} />
              </button>
            ))}
          </div>
        </div>

        <div className="details-section">
          <div className="booking-card">
            <div className="price-section">
              <h3>Book This Package</h3>
              {package_.price && (
                <div className="price">
                  <span className="amount">₹{package_.price.toLocaleString()}</span>
                  <span className="per">per person</span>
                </div>
              )}
            </div>
            <div className="action-buttons">
              <button className="book-now">Book Now</button>
              <button className="enquire">Enquire</button>
            </div>
          </div>

          <div className="description-card">
            <h2>Overview</h2>
            <p className="lead">{package_.shortDescription}</p>
            <div className="highlights">
              <h3>Package Highlights</h3>
              <ul>
                {package_.highlights?.map((highlight, idx) => (
                  <li key={idx}>{highlight}</li>
                ))}
              </ul>
            </div>
          </div>

          <div className="itinerary-card">
            <h2>Day by Day Itinerary</h2>
            <div className="timeline">
              {package_.daysPlan?.map((day, idx) => (
                <div key={idx} className="day-item">
                  <div className="day-marker">
                    <div className="day-number">Day {day.dayNumber}</div>
                  </div>
                  <div className="day-content">
                    <h3>{day.title}</h3>
                    {day.overnightStay && (
                      <div className="overnight">
                        <span className="icon">🏨</span> {day.overnightStay}
                      </div>
                    )}
                    <p>{day.description}</p>
                    {day.activities?.length > 0 && (
                      <div className="activities">
                        {day.activities.map((activity, i) => (
                          <div key={i} className="activity-item">
                            <span className="time">{activity.timeOfDay}</span>
                            <div className="activity-content">
                              <strong>{activity.activity}</strong>
                              {activity.notes && <p>{activity.notes}</p>}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Package;